// About — where the TMDB attribution lives (CLAUDE.md: TMDB terms).
//
// TMDB's API terms require the notice to be placed "prominently in or on Your
// Application", and their developer FAQ puts attribution "within your
// application's 'About' or 'Credits' type section". This is that section: the
// notice, their logo and a link to them, in one place that every page reaches
// from the header. It is not required on every page, which is what lets the
// game screens do without a footer.
import './Info.css';

export function About() {
  return (
    <main className="column info">
      <h1 className="info-title">About</h1>

      <p className="info-line">
        Cinemore is a daily film quiz: a new Running Order every day, and Call Sheet whenever
        you like.
      </p>

      <section className="info-section">
        <h2 className="heading info-heading">Data and images</h2>
        <p className="info-line">
          Movie and television data, photographs and posters come from{' '}
          <a href="https://www.themoviedb.org" target="_blank" rel="noreferrer">TMDB</a>.
        </p>
        {/* TMDB's own logo file, from their logos-and-attribution page, and their
            own wording, unaltered. */}
        <img className="info-logo" src="/tmdb.svg" alt="The Movie Database (TMDB)" />
        <p className="info-notice">
          This product uses the TMDB API but is not endorsed or certified by TMDB.
        </p>
      </section>
    </main>
  );
}
